import React, { Component } from "react";
import * as s from "./Breadcrumbs.module.scss";
import { P, DynamicLink } from "src/views/shared/components";
import { inject, observer } from "mobx-react";
import { ContextStore } from "src/stores";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  contextStore?: ContextStore;
}

@inject("contextStore")
@observer
export class Breadcrumbs extends Component<Props> {
  renderBreadcrumb = (breadcrumbs, key, originalArray) => {
    const { onClick } = this.props;
    const { url, text } = breadcrumbs;
    let lastItem = originalArray.length - 1 === key;

    let breadcrumbItemLabelClasses = [s.breadcrumbItemLabel];
    if (lastItem) breadcrumbItemLabelClasses.push(s.lastItem);
    return (
      <div className={s.breadcrumbItem} key={key}>
        <DynamicLink to={url} className={s.breadcrumbLink} onClick={onClick}>
          <P
            medium
            className={breadcrumbItemLabelClasses.join(" ")}
            dangerouslySetInnerHTML={{ __html: text.replace(/-/g, " ") }}
          />
        </DynamicLink>
        {!lastItem && (
          <P medium className={s.breadcrumbSepatator}>
            {"·"}
          </P>
        )}
      </div>
    );
  };

  render() {
    const { contextStore, className } = this.props;
    const { context } = contextStore;
    if (!context || !context.seo || !context.seo.breadcrumbs) return <></>;
    const { breadcrumbs } = context?.seo;
    let breadcrumbsWrapperClasses = [s.breadcrumbsWrapper];
    if (className) breadcrumbsWrapperClasses.push(className);
    return (
      <div className={breadcrumbsWrapperClasses.join(" ")}>
        {breadcrumbs?.map(this.renderBreadcrumb)}
      </div>
    );
  }
}
